import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'antd';
import { useQuery, useMutation } from 'react-query';
import { DeleteOutlined, SaveOutlined } from '@ant-design/icons';

import { getParameterMessage, postParameterMessage, deleteParameterMessage } from '../../../../services/dataset.service';

const ParameterMessage = (props) => {
  const { parameterId } = props;

  const { data } = useQuery(
    ['parameterMessage', parameterId],
    () => getParameterMessage(parameterId),
  );

  const [message, setMessage] = React.useState(data);

  useEffect(() => {
    if (data) {
      setMessage(data.message || '');
    } else {
      setMessage('');
    }
  }, [data]);

  const saveMessage = useMutation((message) => postParameterMessage(parameterId, message));

  const clearMessage = useMutation(() => deleteParameterMessage(parameterId, data?.parameter_message_id));

  const onChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSave = () => {
    if (message.trim()) {
      saveMessage.mutate(message);
    }
  };

  const handleClear = () => {
    setMessage('');
    clearMessage.mutate();
  };

  return (
    <Card
    // variant="borderless"
      bordered={false}
      title="Parameter Message"
      style={{
        backgroundColor: '#03304b', // TODO: replace with brand var
        border: '1px solid #4f6f81',
        color: 'white',
      }}
    >
      <textarea
        value={message}
        onChange={onChange}
        className="platform-message-textarea"
      />
      <div className="action-buttons">
        <Button
          onClick={handleClear}
          loading={clearMessage.isLoading}
          icon={<DeleteOutlined />}
          className="action-button"
        >
          Clear
        </Button>
        <Button
          icon={<SaveOutlined />}
          className="action-button"
          onClick={handleSave}
          loading={saveMessage.isLoading}
        >
          Save
        </Button>
      </div>
    </Card>
  );
};

ParameterMessage.propTypes = {
  parameterId: PropTypes.number,
};

ParameterMessage.defaultProps = {
  parameterId: undefined,
};

export default ParameterMessage;
